import React, { Fragment, useContext, useRef } from 'react';
import useTestimonialStyles from './styles';
import TopRightComponent from '../../components/quoteComponent';
import PageContext from '../../contexts/pageContext';
import Carousel from '../../components/carousel';

import NextImageRenderer from '../../components/nextImageRenderer';

function Section({ nodeData, sectionIndex }) {
  const {
    isMobile,
    layout: { containerWidth }
  } = useContext(PageContext);

  const carouselList = nodeData?.cardCarousel?.components;
  const cardsCount = carouselList?.length;
  const slidesToShow = isMobile ? 1 : 2;

  const classes = useTestimonialStyles({
    containerWidth,
    cardsCount,
    slidesToShow,
    isMobile
  });
  const settings = {
    className: classes.sliderContainer,
    slidesToShow,
    centerMode: true,
    centerPadding: isMobile ? '0px 0 0' : '80px 0 0'
  };

  const carouselContent = carouselList.map((el, idx) => (
    // kept an extra element as slick mutates this element and gives it 100% width
    // and so, we can't use margins here on the top level element
    <Fragment key={idx}>
      <div className={classes.singleCard}>
        <div className={classes.quoteIcon}>
          <TopRightComponent />
        </div>
        <div className={classes.cardDetails}>
          <p
            ref={el?.cardTextContent?.refSetter}
            className={classes.reviewText}
            dangerouslySetInnerHTML={{
              __html: el?.cardTextContent?.metadata?.value
            }}
          />
          <div className={classes.userContainer}>
            {el?.cardUserImage?.metadata?.value ? (
              // <img
              //   ref={el?.cardUserImage?.refSetter}
              //   className={classes.userImage}
              //   src={el?.cardUserImage?.metadata?.value}
              //   alt="userImg"
              // />
              <div className={classes.userImageContainer}>
                <NextImageRenderer
                  ref={el?.cardUserImage?.refSetter}
                  className={classes.userImage}
                  src={el?.cardUserImage?.metadata?.value}
                  alt="userImg"
                  sectionIndex={sectionIndex}
                />
              </div>
            ) : (
              <div
                ref={el?.cardUserImage?.refSetter}
                className={classes.userImageDummy}
              />
            )}
            <h3
              ref={el?.cardUserName?.refSetter}
              className={classes.userName}
              dangerouslySetInnerHTML={{
                __html: el?.cardUserName?.metadata?.value
              }}
            />
          </div>
        </div>
      </div>
    </Fragment>
  ));

  return (
    <>
      <div className={classes.sectionContainer}>
        <div className={classes.testimonialCardAndText}>
          <div className={classes.testimonialText}>
            <span
              ref={nodeData?.carouselHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.carouselHeading?.metadata?.value
              }}
            />
          </div>
          <h2 className={classes.testimonialHeader}>
            <span
              ref={nodeData?.title?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData?.title?.metadata?.value
              }}
            />
          </h2>

          {cardsCount > slidesToShow ? (
            <Carousel hideArrow={isMobile} settings={settings}>
              {carouselContent}
            </Carousel>
          ) : (
            <div className={classes.contentRow}>{carouselContent}</div>
          )}
        </div>
      </div>
    </>
  );
}

export default function Testimonials({ sectionData, sectionIndex }) {
  const classes = useTestimonialStyles();
  return (
    <div className={classes.testimonialContainer}>
      <Section
        nodeData={sectionData.components[0]}
        sectionIndex={sectionIndex}
      />
    </div>
  );
}
